export const sendOwnershipAnalytics = ({
  reassignSplitError,
  type,
  assetType,
  trackId,
  songwriterError,
  releaseId,
  validate,
  ownersError,
  sendAnalytics,
}: {
  reassignSplitError?: boolean;
  type: string;
  assetType?: 'TRACK' | 'MERCH';
  trackId: string;
  songwriterError?: boolean;
  ownersError?: boolean;
  releaseId: string;
  validate?: boolean;
  sendAnalytics: (
    field: string,
    value: string,
    error: string,
    releaseId?: string
  ) => void;
}) => {
  if (reassignSplitError && type === 'OWNER' && assetType === 'MERCH') {
    sendAnalytics(
      'Release Error Ownership Split',
      '',
      'MERCH.SPLIT_OWNERS',
      trackId
    );
  }
  if (reassignSplitError && type === 'WRITER' && assetType === 'TRACK') {
    sendAnalytics(
      'Release Error Ownership Split',
      '',
      'RELEASE.SPLIT_OWNERS',
      trackId
    );
  }
  if (reassignSplitError && type === 'OWNER' && assetType === 'TRACK') {
    sendAnalytics(
      'Release Error Ownership Split',
      '',
      'RELEASE.SPLIT_OWNERS',
      trackId
    );
  }
  if (
    reassignSplitError &&
    type === 'WRITER' &&
    songwriterError &&
    assetType === 'TRACK'
  ) {
    sendAnalytics(
      'Release Missing Song Writer',
      '',
      'RELEASE.MISSING_SONGWRITER',
      releaseId
    );
  }

  if (validate && type === 'OWNER' && ownersError && assetType === 'TRACK') {
    sendAnalytics(
      'Release Missing Owners',
      '',
      'RELEASE.MISSING_OWNERS',
      releaseId
    );
  }

  if (validate && type === 'OWNER' && ownersError && assetType === 'MERCH') {
    sendAnalytics('Merch Missing Owners', '', 'MERCH.MISSING_OWNERS', trackId);
  }
};
